import { FC } from "react";
import { useLocation } from "react-router-dom";
import { Progress } from "@chakra-ui/react";
import { MaxContentSection } from "~/components";
import { useMetaByPathConfig } from "./hooks/useMetaByPathConfig";
import { useNav } from "./useNav";

export const ProgressBar: FC = () => {
  const location = useLocation();
  const { stepPercent } = useNav();
  const { metaByPath } = useMetaByPathConfig();

  const currentPath = location.pathname;

  if (metaByPath[currentPath].excludeFromProgress) {
    return null;
  }

  return (
    <MaxContentSection maxW="160rem" px={0}>
      <Progress
        bg="th.cream2"
        borderRadius="none"
        color="th.blueGreen2"
        h={2}
        value={stepPercent}
      />
    </MaxContentSection>
  );
};
